import axios from "axios";
import { CLIENT_ORDER } from "../config/clientConfig";

const healthCheckEndpoint = "/awshealthcheck"; //colocar num ficheiro .env
const getHealtCheckDataEndpoint = "/gwhealthcheck-retrieve"; //colocar num ficheiro .env

const gwHealthCheckHandler = axios.create({
    baseURL: "https://mjjb8dkeu7.execute-api.eu-west-1.amazonaws.com/default" //colocar num ficheiro .env
})

// Real endpoints for 5 clients
const clientEndpoints = [
    "https://mjjb8dkeu7.execute-api.eu-west-1.amazonaws.com/default",
    "https://mjjb8dkeu7.execute-api.eu-west-1.amazonaws.com/default",
    "https://mjjb8dkeu7.execute-api.eu-west-1.amazonaws.com/default",
    "https://mjjb8dkeu7.execute-api.eu-west-1.amazonaws.com/default",
    "https://mjjb8dkeu7.execute-api.eu-west-1.amazonaws.com/default"
];

/**
 * Checks if the Health Check Service is running by making a GET request to the specified health check endpoint.
 * @returns {Promise<*>} A promise that resolves to the `fact` field from the response.
 * @throws {Error} If there is any error during the request, throws an error with the message.
 */
export const isHealthCheckServiceRunning = async () => {
    try {
        const response = await gwHealthCheckHandler.get(healthCheckEndpoint, {
            headers: {
                'content-Type': 'application/json',
            }
        });        
        return response.fact;
    } catch (error) {
        throw Error(error.message);
    }
}

/**
 * Retrieves health check statistics fby making a GET request to the specified endpoint.
 * @returns {Promise<*>} A promise that resolves to the `fact` field from the response.
 * @throws {Error} If there is any error during the request, throws an error with the message.
 */
export const callHealthCheckStatisticQueues = async () => {
    try {
        const response = await gwHealthCheckHandler.get(getHealtCheckDataEndpoint, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response;
    } catch (error) {
        console.error("Error in callHealthCheckStatisticQueues:", error);
        throw error;
    }
}

export const fetchClientHealthData = async (clientName) => {
    // Map clientName to index (assumes order: ClientA, ClientB, ...)
    const clientIndex = CLIENT_ORDER.indexOf(clientName);
    if (clientIndex === -1) throw new Error("Unknown client: " + clientName);
    const baseURL = clientEndpoints[clientIndex];
    try {
        const response = await axios.get(baseURL + getHealtCheckDataEndpoint, {
            headers: { 'Content-Type': 'application/json' }
        });
        return { client: clientName, status: "ok", data: response.data };
    } catch (error) {
        throw new Error(error.message || `Failed to fetch data for ${clientName}`);
    }
};